import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AuthService } from '../../../services/AuthService';


export const getVisited = createAsyncThunk('visited/getVisited', async (options, { rejectWithValue }) => {
  // Make request to get user's visited parks.

  const visited = await AuthService.makeRequest({ 
      urlExtension: 'user/visited/', 
      method: 'GET', 
      body: null,
  });

  if (visited.error) {
    return rejectWithValue(visited.error);
  } else {
    return visited.data;
  }
})

export const toggleVisited = createAsyncThunk('visited/toggleVisited', async (options, { rejectWithValue }) => {
  // Make request to toggle the "visited" status of a park for a user.
  const { id } = options;

  const updatedVisited = await AuthService.makeRequest({ 
    urlExtension: 'user/visited/', 
    method: 'POST', 
    body: id,
  });

  if (updatedVisited.error) {
    return rejectWithValue(updatedVisited.error);
  } else {
    return updatedVisited.data;
  }
})

export const visitedSlice = createSlice({
  name: 'visited',
  initialState: {
    visited: [],
    visitedStatus: 'idle',
    visitedError: null,
    toggleStatus: 'idle',
    toggleError: null,
  },
  reducers: {
    setToggleStatus: (state, action) => {
      state.toggleStatus = action.payload;
    },
    clearVisited(state) {
      state.visited = [];
      state.visitedStatus = 'idle';
      state.visitedError = null;
      state.toggleStatus = 'idle';
      state.toggleError = null;
    }
  },
  extraReducers(builder) {
    builder
    .addCase(getVisited.pending, (state) => {
      state.visitedStatus = 'loading';
      state.visitedError = null;
    })
    .addCase(getVisited.fulfilled, (state, action) => {
      state.visitedStatus = 'succeeded'
      state.visited = action.payload;
    })
    .addCase(getVisited.rejected, (state, action) => {
      state.visitedStatus = 'failed';
      state.visitedError = action.error.message;
    })
    .addCase(toggleVisited.pending, (state) => {
      state.toggleStatus = 'loading';
      state.visitedError = null;
    })
    .addCase(toggleVisited.fulfilled, (state, action) => {
      state.toggleStatus = 'succeeded'
      state.visited = action.payload;
    })
    .addCase(toggleVisited.rejected, (state, action) => {
      state.toggleStatus = 'failed';
      state.toggleError = action.error.message;
    })
  },
});

export const { setToggleStatus, clearVisited } = visitedSlice.actions;

export const selectVisited = (state) => state.visited.visited;
export const selectVisitedStatus = (state) => state.visited.visitedStatus;
export const selectVisitedError = (state) => state.visited.visitedError;
export const selectToggleStatus = (state) => state.visited.toggleStatus;

export default visitedSlice.reducer;
